
import React from "react";
import { connect } from "react-redux";
import Avatar from "Components/common/Avatar/Avatar";

@connect(store => {
    return {
        conversations: store.conversations,
        loggedUser: store.loggedUser
    }
})

class DetailsTab extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { dispatch, isAdmin, conversations, loggedUser } = this.props;

        if( conversations.selected.id ) {
            const selected = conversations.selected;
            const creator  = selected.creator;
            const project  = selected.project;
            const note     = selected.note;
            const isAdminNotMember = loggedUser.data.userRole < 3 && conversations.selected.tagged_users.filter( u => u.linkId === loggedUser.data.id ).length === 0;
            const isMember = conversations.selected.tagged_users.filter(t=>t.linkId === loggedUser.data.id);
            const date = moment(selected.dateAdded).format("DD-MMM YYYY") ;

            const handleChange = (e) => {
                dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_ONLY", selected: { ...selected, note: e.target.value }});
            };

            return (
                <div class="detailsWrapper">
                    <form>
                        <div class="formContainer">
                            <label for="subject">Subject</label>
                            {isAdmin && !isAdminNotMember && !selected.isArchived && isMember.length > 0 ? (
                                <input type="text" name="subject" placeholder="Type here" maxlength="80" class="" value={ note } onChange={handleChange}/>
                            ) : (
                                <span>{ note }</span>
                            )}
                        
                        </div>
                        <div class="formContainer">
                            <label for="subject">Created By</label>
                            <div class="nameContainer">
                                <Avatar id={`${creator.id}-member`} name={`${creator.firstName} ${creator.lastName}`} image={creator.avatar !== "default.png" ? `/api/file/profile_pictures/${creator.avatar}` : null} />
                                <p class="m0">{`${ creator.firstName } ${ creator.lastName } on ${date}`}</p>
                            </div>
                        </div>
                        <div class="formContainer">
                            <label for="subject">Account</label>
                            <p>{ project.project }</p>
                        </div>
                    </form>
                </div>
            );
        }

        return null;
    }
}

export default DetailsTab;